module.exports = __webpack_public_path__ + "static/media/mobile-header.4314dda0.png";